import { Button } from '@consigli/shadcn';
import { AlertTriangle } from 'lucide-react';
import { FC, ReactNode } from 'react';

import { Modal } from './modal';

interface ModalAlertProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  loadingText?: string;
  destructive?: boolean;
  trigger?: ReactNode;
}

export const ModalAlert: FC<ModalAlertProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  title,
  description,
  confirmText = 'Continue',
  cancelText = 'Cancel',
  isLoading = false,
  loadingText = 'Loading...',
  destructive = false,
  trigger,
}) => {
  const footer = (
    <>
      <Button
        variant="outline"
        onClick={() => onOpenChange(false)}
        disabled={isLoading}
        className="min-w-[80px]"
      >
        {cancelText}
      </Button>
      <Button
        onClick={onConfirm}
        disabled={isLoading}
        className={`min-w-[80px] ${
          destructive
            ? 'bg-red-600 hover:bg-red-700 focus:ring-red-600'
            : 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-600'
        }`}
      >
        {isLoading ? loadingText : confirmText}
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={
        <div className="flex items-center gap-3">
          {destructive && (
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
          )}
          <span>{title}</span>
        </div>
      }
      description={description}
      footer={footer}
      trigger={trigger}
      showCloseButton={false}
    />
  );
};
